// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bAhWFq4VhE1f5r3bpoQG {
  display: flex;
  flex-direction: column;
  row-gap: 16px;
}

.wc1rfC88gYg_gHpaBqjj {
  width: 50px;
  height: 50px;
}

.MWJeZFdBlJakn_AqvhlQ {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  padding: 24px;
}

.d0z_sNCh_dpYYcBolz1u {
  display: flex;
  flex-direction: row;
  column-gap: 18px;
  align-items: center;
}

.zFQIRfiWY0dZQ444Y19I {
  font-family: "Chakra Petch";
  font-size: 20px;
  font-weight: bold;
  color: white;
}

.T4tSMYoq99XOxa7EHXHm {
  font-family: "Chakra Petch";
  font-size: 18px;
  color: white;
}

.d5m0pLwVknZYaareebOV {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
}

.qUimBWOvq1i1cvcYeOip {
  display: flex;
  flex-direction: column;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.d1ukls5bVgyikAkNEk93, .uHSbN3D89iwTddFTMHOM {
  display: grid;
  grid-template-columns: 140px 1fr 2fr 250px 60px;
  font-family: "Chakra Petch";
  font-size: 16px;
  color: white;
  width: 100%;
  padding: 16px;
  cursor: pointer;
}
.d1ukls5bVgyikAkNEk93:hover, .uHSbN3D89iwTddFTMHOM:hover {
  background-color: rgba(255, 255, 255, 0.0666666667);
}

.uHSbN3D89iwTddFTMHOM {
  background-color: rgba(255, 255, 255, 0.0666666667);
}

.myWzXEO2VDOorYR3KJtw {
  display: grid;
  grid-template-columns: 1fr 140px 2fr 200px 160px;
  width: 100%;
  font-family: "Chakra Petch";
  font-size: 14px;
  color: white;
}
.myWzXEO2VDOorYR3KJtw > span {
  margin: auto 0;
}

.ktT7UfUf9o6ExyO70Azw, .u4tNzDvNVXRI_NkYmAkA {
  display: flex;
  flex-direction: column;
  row-gap: 8px;
  padding: 0;
  max-height: 0px;
  opacity: 0;
  overflow: hidden;
  transition: all 0.2s ease-in-out;
  width: 100%;
}

.u4tNzDvNVXRI_NkYmAkA {
  max-height: 1000px;
  opacity: 1;
  overflow: visible;
  padding: 8px 16px;
}

.ibnh_wLlWKNQq_lWgMr6 {
  font-family: "Chakra Petch";
  font-size: 14px;
  color: white;
  cursor: pointer;
  text-transform: uppercase;
  font-weight: bold;
  padding: 8px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
}
.ibnh_wLlWKNQq_lWgMr6:hover {
  color: #48CAE4;
}

.q5Wm4xgp9Zq1DnjjyGJT {
  color: #D62828;
}

.Q7qhhVITXrct7Jf1GVXw {
  color: rgba(0, 209, 140, 0.9);
}

.a5eUqWGiXXIYJtN5AoGF, .X3_OuEXK95jp2S27M7se {
  color: white;
  transition: all 0.2s ease-in-out;
}

.X3_OuEXK95jp2S27M7se {
  transform: rotate(180deg);
}`, "",{"version":3,"sources":["webpack://./src/screens/RaffleEdit/RaffleParticipantsList.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,2BAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AACF;;AAEA;EACE,2BAAA;EACA,eAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,0CAAA;AACF;;AAEA;EACE,aAAA;EACA,+CAAA;EACA,2BAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;AACF;AAAE;EACE,mDAAA;AAEJ;;AAEA;EAEE,mDAAA;AAAF;;AAGA;EACE,aAAA;EACA,gDAAA;EACA,WAAA;EACA,2BAAA;EACA,eAAA;EACA,YAAA;AAAF;AAEE;EACE,cAAA;AAAJ;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;EACA,gCAAA;EACA,WAAA;AADF;;AAIA;EAEE,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,2BAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;AAFF;AAGE;EACE,cAAA;AADJ;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,6BAAA;AAFF;;AAKA;EACE,YAAA;EACA,gCAAA;AAFF;;AAKA;EAEE,yBAAA;AAHF","sourcesContent":[".missionParticipantsContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  row-gap: 16px;\r\n}\r\n\r\n.rankImage {\r\n  width: 50px;\r\n  height: 50px;\r\n}\r\n\r\n.participantDetailsContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  row-gap: 24px;\r\n  padding: 24px;\r\n}\r\n\r\n.participantDetailsRow {\r\n  display: flex;\r\n  flex-direction: row;\r\n  column-gap: 18px;\r\n  align-items: center;\r\n}\r\n\r\n.participantDetailsLabel {\r\n  font-family: \"Chakra Petch\";\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n  color: white;\r\n}\r\n\r\n.participantDetailsValue {\r\n  font-family: \"Chakra Petch\";\r\n  font-size: 18px;\r\n  color: white;\r\n}\r\n\r\n.participantTasksContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  row-gap: 8px;\r\n}\r\n\r\n.participantTaskRowContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  border: 1px solid #FFFFFF33;\r\n}\r\n\r\n.participantTaskRow {\r\n  display: grid;\r\n  grid-template-columns: 140px 1fr 2fr 250px 60px;\r\n  font-family: \"Chakra Petch\";\r\n  font-size: 16px;\r\n  color: white;\r\n  width: 100%;\r\n  padding: 16px;\r\n  cursor: pointer;\r\n  &:hover {\r\n    background-color: #FFFFFF11;\r\n  }\r\n}\r\n\r\n.participantTaskRowOpen {\r\n  @extend .participantTaskRow;\r\n  background-color: #FFFFFF11;\r\n}\r\n\r\n.participantSubTaskRow {\r\n  display: grid;\r\n  grid-template-columns: 1fr 140px 2fr 200px 160px;\r\n  width: 100%;\r\n  font-family: \"Chakra Petch\";\r\n  font-size: 14px;\r\n  color: white;\r\n\r\n  & > span {\r\n    margin: auto 0;\r\n  }\r\n}\r\n\r\n.participantSubTaskContainer {\r\n  display: flex;\r\n  flex-direction: column;\r\n  row-gap: 8px;\r\n  padding: 0;\r\n  max-height: 0px;\r\n  opacity: 0;\r\n  overflow: hidden;\r\n  transition: all 0.2s ease-in-out;\r\n  width: 100%;\r\n}\r\n\r\n.participantSubTaskContainerOpen {\r\n  @extend .participantSubTaskContainer;\r\n  max-height: 1000px;\r\n  opacity: 1;\r\n  overflow: visible;\r\n  padding: 8px 16px;\r\n}\r\n\r\n.completeSubTaskButton {\r\n  font-family: \"Chakra Petch\";\r\n  font-size: 14px;\r\n  color: white;\r\n  cursor: pointer;\r\n  text-transform: uppercase;\r\n  font-weight: bold;\r\n  padding: 8px;\r\n  border: 1px solid #FFFFFF33;\r\n  border-radius: 4px;\r\n  &:hover {\r\n    color: #48CAE4;\r\n  }\r\n}\r\n\r\n.statusFailed {\r\n  color: #D62828;\r\n}\r\n\r\n.statusCompleted {\r\n  color: rgba(0, 209, 140, 0.9);\r\n}\r\n\r\n.caretIcon {\r\n  color: white;\r\n  transition: all 0.2s ease-in-out;\r\n}\r\n\r\n.caretIconRotated {\r\n  @extend .caretIcon;\r\n  transform: rotate(180deg);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"missionParticipantsContainer": `bAhWFq4VhE1f5r3bpoQG`,
	"rankImage": `wc1rfC88gYg_gHpaBqjj`,
	"participantDetailsContainer": `MWJeZFdBlJakn_AqvhlQ`,
	"participantDetailsRow": `d0z_sNCh_dpYYcBolz1u`,
	"participantDetailsLabel": `zFQIRfiWY0dZQ444Y19I`,
	"participantDetailsValue": `T4tSMYoq99XOxa7EHXHm`,
	"participantTasksContainer": `d5m0pLwVknZYaareebOV`,
	"participantTaskRowContainer": `qUimBWOvq1i1cvcYeOip`,
	"participantTaskRow": `d1ukls5bVgyikAkNEk93`,
	"participantTaskRowOpen": `uHSbN3D89iwTddFTMHOM`,
	"participantSubTaskRow": `myWzXEO2VDOorYR3KJtw`,
	"participantSubTaskContainer": `ktT7UfUf9o6ExyO70Azw`,
	"participantSubTaskContainerOpen": `u4tNzDvNVXRI_NkYmAkA`,
	"completeSubTaskButton": `ibnh_wLlWKNQq_lWgMr6`,
	"statusFailed": `q5Wm4xgp9Zq1DnjjyGJT`,
	"statusCompleted": `Q7qhhVITXrct7Jf1GVXw`,
	"caretIcon": `a5eUqWGiXXIYJtN5AoGF`,
	"caretIconRotated": `X3_OuEXK95jp2S27M7se`
};
export default ___CSS_LOADER_EXPORT___;
